"use client";

import { c as _c } from "react/compiler-runtime";
import { startTransition, useEffect, useRef, useState } from "react";
const useScroll = t0 => {
  const $ = _c(11);
  const {
    threshold,
    debounceDelay: t1
  } = t0;
  const debounceDelay = t1 === undefined ? 100 : t1;
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const timeoutRef = useRef(null);
  const scrollStateRef = useRef(false);
  let t2;
  if ($[0] !== debounceDelay || $[1] !== threshold) {
    t2 = () => {
      const currentScrollY = window.scrollY;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        startTransition(() => {
          const hasScrolledPastThreshold = currentScrollY > threshold;
          if (hasScrolledPastThreshold !== scrollStateRef.current) {
            scrollStateRef.current = hasScrolledPastThreshold;
            setIsScrolled(hasScrolledPastThreshold);
          }
          setScrollPosition(currentScrollY);
        });
      }, debounceDelay);
    };
    $[0] = debounceDelay;
    $[1] = threshold;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleScroll = t2;
  let t3;
  if ($[3] !== handleScroll) {
    t3 = () => {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    };
    $[3] = handleScroll;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== debounceDelay || $[6] !== threshold) {
    t4 = [threshold, debounceDelay];
    $[5] = debounceDelay;
    $[6] = threshold;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== isScrolled || $[9] !== scrollPosition) {
    t5 = {
      isScrolled,
      scrollPosition
    };
    $[8] = isScrolled;
    $[9] = scrollPosition;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default useScroll;